import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

class SponsorsDataService extends APIBaseFunctions {
  private cachedSponsorsDataSliceObj: APIDataSliceObj = {
    slicemode: 0,
    start: 0,
    limit: defaultAPILimit,
    page: 0,
    pagesize: 0,
    totalcount: 0
  }

  getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    const currentDataSliceObj = SponsorsDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedSponsorsDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      return http.get(`/sponsors?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    return http.get(`/sponsors?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
  }

  getPopulatedData () {
    return http.get('/sponsors?populate[sponsor_billede]=true')
  }

  get (id: string) {
    return http.get(`sponsors/${id}?populate=*`)
  }

  getCount (extraCountParameter = '') {
    return http.get('/sponsors/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
  }

  create (data: any) {
    return http.post('/sponsors', data)
  }

  update (id: string, data: any) {
    return http.put(`/sponsors/${id}?populate=*`, data)
  }

  delete (id: string) {
    return http.delete(`/sponsors/${id}`)
  }

  deleteAll () {
    return http.delete('sponsors/')
  }

  findBySponsorStatus (status: boolean, sortingOrder = '') {
    let sortingOrderParameter = ''

    if (sortingOrder.length > 0) {
      sortingOrderParameter = `&_sort=${sortingOrder}`
    }

    return http.get(`/sponsors?filters[sponsor_status][$eq]=${status}${sortingOrderParameter}&populate=*`)
  }

  findBySearchTerm (status: boolean, ignoreStatus: boolean, searchTerm: string, sortingOrder = '') {
    let retVal
    let sortingOrderParameter = ''

    if (sortingOrder.length > 0) {
      sortingOrderParameter = `&_sort=${sortingOrder}`
    }
    // Do a search in sponsor names for the search term
    if (ignoreStatus) {
      retVal = http.get(`/sponsors?filters[sponsor_sponsornavn][$contains]=${searchTerm}${sortingOrderParameter}&populate=*`)
    } else {
      retVal = http.get(`/sponsors?filters[sponsor_status][$eq]=${status}&filters[sponsor_sponsornavn][$contains]=${searchTerm}${sortingOrderParameter}&populate=*`)
    }

    return retVal
  }
}

export default new SponsorsDataService()
